// *** ProfileBio Component ****
import React, { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";


const ProfileBio = (props) => {
    const Group = require("../../assets/img/Featured icon.jpg");

    return (
        <div>
            <Modal show={props.isBio} onHide={props.handleClose} dialogClassName="custom-modal">
                <Modal.Header closeButton>
                    <div className="popupheader">
                        <div className="header mt-2">
                            <div className="signuup">{`${props.name} Bio` }</div>
                            
                        </div>
                    </div>

                </Modal.Header>
                <Modal.Body>
                    <div >
                        <div className="my-bio">
                            <p>{props.content}</p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="modal-center" >
                    <Button variant="secondary" className="pop-primary" onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>

        </div >
    );
};
export default ProfileBio;
